import { render, staticRenderFns } from "./PresenceDetailTable.vue?vue&type=template&id=12f06845"
import script from "./PresenceDetailTable.vue?vue&type=script&lang=js"
export * from "./PresenceDetailTable.vue?vue&type=script&lang=js"
import style0 from "./PresenceDetailTable.vue?vue&type=style&index=0&id=12f06845&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports